import { render, staticRenderFns } from "./CandidateInfoCard.vue?vue&type=template&id=432fb31c&"
import script from "./CandidateInfoCard.vue?vue&type=script&lang=js&"
export * from "./CandidateInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./CandidateInfoCard.vue?vue&type=style&index=0&id=432fb31c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports